import { OrdersSection } from "src/apps/components/ordersSection/OrdersSection";
import { PayslipsContent } from "./PayslipsContent";
import { OrderPayslip } from "src/contexts/documentationArea/domain/OrderPayslip";

const ACCORDION_HEADER_PAYSLIPS_HEADER = "documentation_area.payslips.section_header";
const ACCORDION_HEADER_PAYSLIPS_DESCRIPTION = "documentation_area.payslips.section_description";

interface PayslipsProps {
  payslips: OrderPayslip[];
}

export const Payslips = ({ payslips }: PayslipsProps) => {
  if (!payslips.length) return null;

  return (
    <OrdersSection
      title={ACCORDION_HEADER_PAYSLIPS_HEADER}
      description={ACCORDION_HEADER_PAYSLIPS_DESCRIPTION}
      content={<PayslipsContent payslips={payslips} />}
      isCompleted={false}
    />
  );
};
